'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { cn } from '@core/utils';
import { SvgChevrondown } from '@wello-client/react/__generated__/icon';
import { RecommendedGiftCard, type RecommendedGiftCardProps } from './RecommendedGiftCard';
export interface RecommendedGiftsSectionProps {
  gifts: RecommendedGiftCardProps[];
  onMoreClick?: () => void;
  onLoadMore?: () => void;
  hasMore?: boolean;
  isLoadingMore?: boolean;
  onAddToCart?: (productNumber: string) => void;
  className?: string;
}
export const RecommendedGiftsSection = t0 => {
  const $ = _c(22);
  const {
    gifts,
    onMoreClick,
    onLoadMore,
    hasMore,
    isLoadingMore,
    onAddToCart,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-16 rounded-xlarge ", "mobile-tablet:min-w-0 mobile-tablet:gap-8 mobile-tablet:rounded-none mobile-tablet:bg-Gray-white", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="font-700 text-Gray-900 typo-body2 mobile-tablet:pl-20">답례품을 더 담아보세요</h2>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onMoreClick) {
    t3 = <div className="flex items-center justify-between mobile-tablet:pr-20">{t2}<button type="button" onClick={onMoreClick} aria-label={"\uB354 \uB9CE\uC740 \uCD94\uCC9C \uB2F5\uB840\uD488 \uBCF4\uAE30"} className="hidden font-600 text-Gray-600 typo-caption2 mobile-tablet:block">더보기</button></div>;
    $[3] = onMoreClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("grid grid-cols-4 gap-x-16 gap-y-24", "scrollbar-hide mobile-tablet:flex mobile-tablet:min-w-0 mobile-tablet:gap-12 mobile-tablet:overflow-x-auto mobile-tablet:pb-24 mobile-tablet:pl-20");
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== gifts || $[7] !== onAddToCart) {
    let t6;
    if ($[9] !== onAddToCart) {
      t6 = gift => <RecommendedGiftCard key={gift.productNumber} {...gift} onAddToCart={() => onAddToCart?.(gift.productNumber)} className="w-full mobile-tablet:w-160 mobile-tablet:shrink-0" />;
      $[9] = onAddToCart;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = gifts.map(t6);
    $[6] = gifts;
    $[7] = onAddToCart;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== hasMore || $[14] !== isLoadingMore || $[15] !== onLoadMore) {
    t7 = hasMore && <Button dimensions="H48" theme="sub-line" onClick={onLoadMore} disabled={isLoadingMore} className="mx-auto mt-8 w-full max-w-[480px] bg-Gray-white mobile-tablet:hidden mobile-tablet:bg-transparent"><span className="flex items-center gap-4">{isLoadingMore ? "\uBD88\uB7EC\uC624\uB294 \uC911..." : "\uB2F5\uB840\uD488 \uB354\uBCF4\uAE30"}{!isLoadingMore && <SvgChevrondown width={16} height={16} className="text-Gray-700" />}</span></Button>;
    $[13] = hasMore;
    $[14] = isLoadingMore;
    $[15] = onLoadMore;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t3 || $[19] !== t6 || $[20] !== t7) {
    t8 = <section className={t1}>{t3}{t6}{t7}</section>;
    $[17] = t1;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};